import { render } from "./PageExport.vue?vue&type=template&id=0a1b4548"
import script from "./PageExport.vue?vue&type=script&lang=js"
export * from "./PageExport.vue?vue&type=script&lang=js"

import "./PageExport.vue?vue&type=style&index=0&id=0a1b4548&lang=css"
script.render = render

export default script